import { memo } from "react";
import useIsMobile from "../hooks/useIsMobile";
import Dropdown from "./Dropdown";
import "../styles/dropdown.css";

const TABS = [
  { id: 1, path: "/", label: "News" },
  { id: 2, path: "/movies", label: "Movies" },
  { id: 3, path: "/sports", label: "Sports" },
  // { id: 4, path: "/entertainment", label: "Entertainment" },
  { id: 5, path: "/music", label: "Music" },
  { id: 6, path: "/extra", label: "Extra" },
];

const Tab = ({ getTabButtonClass, onTabSelect, selectedTab }) => {
  const isMobile = useIsMobile();

  return isMobile ? (
    <Dropdown tabs={TABS} onTabSelect={onTabSelect} selectedTab={selectedTab} />
  ) : (
    <div className="tab-button-group">
      <span className="tab-indicator" />
      {TABS.map(({ id, path, label }) => (
        <button
          key={id}
          id={`tab-button-${id}`}
          className={getTabButtonClass(path)}
          onClick={() => onTabSelect(path)}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default memo(Tab);
